import { AxiosError } from 'axios';
import instance from '../config/axios';

export async function downloadDosageDiaryPDF(token: string, profileId: string) {
  try {
    const response = await instance({
      headers: {
        Authorization: `Bearer ${token}`,
        'Content-Type': 'application/pdf',
      },
      method: 'GET',
      responseType: 'blob',
      url: `/api/v1/dosasgedairy/profile/download/${profileId}`,
    });

    return response.data;
  } catch (e) {
    console.log(e);
    return (e as AxiosError).response!.status;
  }
}
